import { FC } from 'react';

import { useRecoilValue } from 'recoil';

import { dateRangeAtom } from '@service/bugo/containers/AgencyAdminBugoListTable/table.atom';
import AgencyAdminBugoStatPage from '@service/bugo/page/AgencyAdminBugoStatPage';
import { useFeventListAgencyAdminHook } from '@shared/api/fevent/fevent.hook';
import { Route, Routes, useParams } from 'react-router-dom';

export const BugoStatRouter: FC = () => {
  const { bugoBrandId } = useParams();
  const bugoBrandId_ = bugoBrandId ?? 'undefined';

  const dateRange = useRecoilValue(dateRangeAtom);

  //* bugoBrand로 가져올 수 있는 부고(fevent)를 가져오는 hook
  useFeventListAgencyAdminHook(bugoBrandId_, dateRange);

  return (
    <Routes>
      <Route path="" element={<AgencyAdminBugoStatPage />} />
    </Routes>
  );
};
